/* ══════════════════════════════════════════════════════════════════════════
   SOMAR V7 — storefront behaviour
   Every module guards on the markup it needs, so one page's missing element
   can never stop another feature from booting.
   ══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var d = document, html = d.documentElement, body = d.body;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var inEditor = !!(window.Shopify && Shopify.designMode);
  var isHome = body.classList.contains('template-index');
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var mqDesk = window.matchMedia('(min-width: 900px)');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(s, r) { return (r || d).querySelector(s); }
  function $$(s, r) { return [].slice.call((r || d).querySelectorAll(s)); }
  function pad(n, l) { n = String(n); while (n.length < (l || 2)) n = '0' + n; return n; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function safe(fn) { try { fn(); } catch (e) { if (window.console) console.error('[somar]', e); } }

  var MONEY_FMT = window.__MONEY_FORMAT__ || '${{amount}}';
  function fmtMoney(cents) {
    var n2 = (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var n0 = Math.round(cents / 100).toLocaleString('en-US');
    var c2 = (cents / 100).toFixed(2).replace('.', ',');
    return MONEY_FMT
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, n0)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, c2)
      .replace(/\{\{\s*amount\s*\}\}/g, n2)
      .replace(/<[^>]+>/g, '');
  }

  /* ── Same-store absolute links ─────────────────────────────────────────
     Menu links saved as absolute https://…myshopify.com URLs hop domains, which drops
     the storefront-password cookie. Rewrite them to stay on the current domain. */
  safe(function () {
    var MYSHOP = /^https?:\/\/[^\/]*\.myshopify\.com(\/|$)/i;
    var SELF = new RegExp('^https?://' + location.host.replace(/\./g, '\\.') + '(/|$)', 'i');
    $$('a[href]').forEach(function (a) {
      var h = a.getAttribute('href');
      if (h && (MYSHOP.test(h) || SELF.test(h))) a.setAttribute('href', h.replace(/^https?:\/\/[^\/]+/i, '') || '/');
    });
  });

  /* ── Page transitions ────────────────────────────────────────────────── */
  var veil = $('#page-transition');
  var veilTimer = null;
  function navigateTo(href) {
    if (!veil || reduceMotion) { location.href = href; return; }
    veil.classList.add('out');
    clearTimeout(veilTimer);
    // Safety: if the browser never leaves (download, 204, blocked), lift the veil again
    veilTimer = setTimeout(function () { veil.classList.remove('out'); }, 2500);
    setTimeout(function () { location.href = href; }, 190);
  }
  window.somarNavigate = navigateTo;

  /* ── Toast ───────────────────────────────────────────────────────────── */
  var toastEl = $('#toast'), toastT = null;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.hidden = false;
    toastEl.style.animation = 'none'; void toastEl.offsetWidth; toastEl.style.animation = '';
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.hidden = true; }, 2600);
  }

  /* ── Overlay stack: drawers, modals, search, lightbox ─────────────────
     One stack so Escape, the scrim, scroll-lock and focus return always agree. */
  var scrim = $('#scrim');
  var stack = [];
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select,textarea,[tabindex]:not([tabindex="-1"])';

  function topLayer() { return stack[stack.length - 1]; }
  function setExpanded(id, v) { $$('[aria-controls="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', v ? 'true' : 'false'); }); }

  function openLayer(el, opts) {
    if (!el) return;
    opts = opts || {};
    if (stack.indexOf(el) !== -1) return;
    var isDrawer = el.classList.contains('drawer');
    // Only one drawer at a time
    if (isDrawer) stack.filter(function (l) { return l.classList.contains('drawer'); }).forEach(function (l) { closeLayer(l, true); });
    el._returnFocus = d.activeElement;
    el.hidden = false;
    stack.push(el);
    html.classList.add('is-locked');
    if (isDrawer && scrim) scrim.hidden = false;
    void el.offsetWidth; // commit the closed state so the slide-in transition runs
    if (isDrawer && scrim) scrim.classList.add('open');
    el.classList.add('open');
    if (el.id) setExpanded(el.id, true);
    var focusTarget = opts.focus ? $(opts.focus, el) : $(FOCUSABLE, el);
    if (focusTarget) setTimeout(function () { try { focusTarget.focus({ preventScroll: true }); } catch (e) { focusTarget.focus(); } }, 60);
  }

  function closeLayer(el, instant) {
    var i = stack.indexOf(el);
    if (i === -1) return;
    stack.splice(i, 1);
    el.classList.remove('open');
    var isDrawer = el.classList.contains('drawer');
    var anyDrawer = stack.some(function (l) { return l.classList.contains('drawer'); });
    if (isDrawer && scrim && !anyDrawer) {
      scrim.classList.remove('open');
      setTimeout(function () { if (!scrim.classList.contains('open')) scrim.hidden = true; }, instant ? 0 : 300);
    }
    var hide = function () { if (!el.classList.contains('open')) el.hidden = true; };
    if (isDrawer && !instant) setTimeout(hide, 340); else hide();
    if (!stack.length) html.classList.remove('is-locked');
    if (el.id) setExpanded(el.id, false);
    if (typeof el._onClose === 'function') el._onClose();
    var rf = el._returnFocus;
    if (rf && rf.focus && !instant) { try { rf.focus({ preventScroll: true }); } catch (e) {} }
  }
  function closeAll() { stack.slice().forEach(function (l) { closeLayer(l, true); }); }
  window.somarOpen = openLayer; window.somarClose = closeLayer;

  if (scrim) scrim.addEventListener('click', function () { var t = topLayer(); if (t) closeLayer(t); });

  d.addEventListener('keydown', function (e) {
    var t = topLayer();
    if (!t) return;
    if (e.key === 'Escape') { e.preventDefault(); closeLayer(t); return; }
    if (e.key === 'Tab') {
      var f = $$(FOCUSABLE, t).filter(function (x) { return x.offsetParent !== null || x === d.activeElement; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && d.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && d.activeElement === last) { e.preventDefault(); first.focus(); }
      else if (!t.contains(d.activeElement)) { e.preventDefault(); first.focus(); }
    }
  });

  // Generic open / close triggers
  d.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      var dr = d.getElementById(opener.getAttribute('data-drawer-open'));
      if (dr && stack.indexOf(dr) !== -1) closeLayer(dr); else openLayer(dr);
      return;
    }
    var closer = e.target.closest('[data-drawer-close],[data-modal-close]');
    if (closer) {
      var layer = closer.closest('.drawer,.modal');
      if (layer) { e.preventDefault(); closeLayer(layer); }
      return;
    }
    var mOpen = e.target.closest('[data-modal-open]');
    if (mOpen) { e.preventDefault(); openLayer(d.getElementById(mOpen.getAttribute('data-modal-open'))); return; }
    // Click on a modal's dimmed backdrop closes it
    if (e.target.classList && e.target.classList.contains('modal') && e.target === topLayer()) closeLayer(e.target);
  });

  /* ── Restricted (coming-soon) gate ───────────────────────────────────── */
  safe(function () {
    var modal = $('#restrict-modal'), form = $('#restrict-form'), input = $('#restrict-input'), err = $('#restrict-error');
    var pending = null;
    window.showRestrictModal = function (href) {
      if (!modal) return;
      pending = href;
      if (input) input.value = '';
      if (err) err.hidden = true;
      openLayer(modal, { focus: '#restrict-input' });
    };
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      var pass = String(window.__RESTRICT_PASS__ || '').trim();
      if (pass && input && input.value.trim().toLowerCase() === pass.toLowerCase()) {
        closeLayer(modal, true);
        if (pending) navigateTo(pending);
      } else {
        if (err) { err.textContent = pass ? 'INCORRECT CODE' : 'ACCESS LOCKED'; err.hidden = false; }
        if (input) { input.value = ''; input.focus(); }
      }
    });
    $$('[data-restrict-cancel]').forEach(function (b) { b.addEventListener('click', function () { closeLayer(modal); }); });
    d.addEventListener('click', function (e) {
      var a = e.target.closest('a[data-restricted]');
      if (!a) return;
      e.preventDefault();
      window.showRestrictModal(a.getAttribute('href'));
    });
  });

  /* Link transitions — registered after the restricted gate so it can veto first */
  d.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest('a[href]');
    if (!a || (a.target && a.target !== '_self') || a.hasAttribute('download') || a.hasAttribute('data-no-veil')) return;
    var raw = a.getAttribute('href');
    if (!raw || raw.charAt(0) === '#' || /^(mailto:|tel:|sms:|javascript:)/i.test(raw)) return;
    var url;
    try { url = new URL(a.href, location.href); } catch (err) { return; }
    if (url.origin !== location.origin) return;
    if (url.pathname === location.pathname && url.search === location.search && url.hash) return;
    e.preventDefault();
    navigateTo(url.href);
  });

  d.addEventListener('click', function (e) {
    var b = e.target.closest('[data-history-back]');
    if (!b) return;
    e.preventDefault();
    var ref = d.referrer;
    if (ref && ref.indexOf(location.origin) === 0 && history.length > 1) history.back();
    else {
      var fallback = $('.win-title a');
      navigateTo(fallback ? fallback.href : ROOT);
    }
  });

  /* ── Night mode (session only — every new visit starts in day mode) ─── */
  safe(function () {
    try { localStorage.removeItem('somar-dark'); } catch (e) {}
    if (inEditor) { html.classList.remove('dark-mode'); body.classList.remove('dark-mode'); }
    else if (html.classList.contains('dark-mode')) body.classList.add('dark-mode');
    function sync() {
      var on = html.classList.contains('dark-mode');
      $$('.dm-label').forEach(function (l) { l.textContent = on ? 'DAY MODE' : 'NIGHT MODE'; });
      $$('.dm-toggle').forEach(function (b) { b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      var meta = $('meta[name="theme-color"]');
      if (meta) meta.setAttribute('content', on ? '#0e0e0e' : '#d4d4d4');
    }
    sync();
    d.addEventListener('click', function (e) {
      if (!e.target.closest('.dm-toggle')) return;
      var on = !html.classList.contains('dark-mode');
      html.classList.toggle('dark-mode', on);
      body.classList.toggle('dark-mode', on);
      try { sessionStorage.setItem('somar-dark', on ? '1' : '0'); } catch (err) {}
      sync();
      if (window.__somarRedraw) window.__somarRedraw();
    });
  });

  /* ── Cart ────────────────────────────────────────────────────────────── */
  function cartSectionIds() {
    var ids = $$('[data-cart-section]').map(function (el) { return el.getAttribute('data-cart-section'); });
    return ids.filter(function (id, i) { return id && ids.indexOf(id) === i; }).slice(0, 5);
  }

  function setCount(n) {
    $$('[data-cart-count]').forEach(function (b) {
      var changed = b.textContent !== String(n);
      b.textContent = n;
      b.hidden = !n;
      if (changed && n) { b.classList.remove('bump'); void b.offsetWidth; b.classList.add('bump'); }
    });
  }

  function renderSections(sections) {
    if (!sections) return false;
    var ok = true;
    Object.keys(sections).forEach(function (id) {
      var markup = sections[id];
      var cur = $('[data-cart-section="' + id + '"]');
      if (!cur) return;
      if (!markup) { ok = false; return; }
      var doc = new DOMParser().parseFromString(markup, 'text/html');
      var fresh = doc.querySelector('[data-cart-section="' + id + '"]');
      if (fresh) cur.innerHTML = fresh.innerHTML; else ok = false;
    });
    var counter = $('[data-cart-section] [data-cart-label]');
    var n = counter ? parseInt(counter.textContent, 10) : NaN;
    if (!isNaN(n)) setCount(n);
    return ok;
  }

  function refreshCart() {
    var ids = cartSectionIds();
    if (!ids.length) return Promise.resolve();
    return fetch(ROOT + '?sections=' + ids.join(','), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (s) { renderSections(s); })
      .catch(function () {});
  }

  function postJSON(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok || (j && j.status && j.status >= 400)) {
          var err = new Error((j && (j.description || j.message)) || 'Request failed');
          err.payload = j; throw err;
        }
        return j;
      });
    });
  }

  function addToCart(variantId, qty, btns) {
    btns = [].concat(btns || []).filter(Boolean);
    btns.forEach(function (b) { b.classList.add('is-busy'); b.setAttribute('aria-busy', 'true'); });
    return postJSON(ROOT + 'cart/add.js', {
      items: [{ id: Number(variantId), quantity: qty || 1 }],
      sections: cartSectionIds().join(','),
      sections_url: location.pathname
    }).then(function (res) {
      if (!renderSections(res.sections)) return refreshCart();
    }).then(function () {
      btns.forEach(function (b) {
        b.classList.remove('is-busy'); b.removeAttribute('aria-busy');
        b.classList.add('is-done');
        setTimeout(function () { b.classList.remove('is-done'); }, 1400);
      });
      var drawer = $('#cart-drawer');
      if (drawer && !body.classList.contains('template-cart')) openLayer(drawer);
      else toast('ADDED TO CART');
    }).catch(function (err) {
      btns.forEach(function (b) { b.classList.remove('is-busy'); b.removeAttribute('aria-busy'); });
      toast((err && err.message ? err.message : 'COULD NOT ADD — TRY AGAIN').toUpperCase());
      throw err;
    });
  }
  window.somarAddToCart = addToCart;

  // Quantity steppers + remove — one delegated handler for drawer and cart page
  d.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cart-qty]');
    if (!b) return;
    var row = b.closest('.cl');
    if (!row || row.classList.contains('busy')) return;
    var line = parseInt(row.getAttribute('data-line'), 10);
    var qty = Math.max(0, parseInt(b.getAttribute('data-cart-qty'), 10) || 0);
    if (!line) return;
    row.classList.add('busy');
    postJSON(ROOT + 'cart/change.js', { line: line, quantity: qty, sections: cartSectionIds().join(','), sections_url: location.pathname })
      .then(function (res) {
        if (!renderSections(res.sections)) return refreshCart();
        if (qty > 0) {
          // Shopify caps quantity at available stock — tell the shopper when that happens
          var item = res.items && res.items[line - 1];
          if (item && item.quantity < qty) toast('ONLY ' + item.quantity + ' AVAILABLE');
        }
      })
      .catch(function (err) {
        row.classList.remove('busy');
        toast((err && err.message ? err.message : 'COULD NOT UPDATE CART').toUpperCase());
        refreshCart();
      });
  });

  // Discount code (cart page) — Shopify applies codes via /discount/CODE
  safe(function () {
    var f = $('[data-discount-form]');
    if (!f) return;
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = $('input', f);
      var code = (input && input.value || '').trim();
      if (!code) { if (input) input.focus(); return; }
      navigateTo(ROOT + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(ROOT + 'cart'));
    });
  });

  /* ── Product cards: desktop quick add ────────────────────────────────── */
  d.addEventListener('click', function (e) {
    var b = e.target.closest('[data-quick-add] [data-variant-id]');
    if (!b || b.disabled) return;
    e.preventDefault();
    addToCart(b.getAttribute('data-variant-id'), 1, b).catch(function () {});
  });

  /* ── Collection tools: in-stock filter + native sort ─────────────────── */
  safe(function () {
    var grid = $('#product-grid');
    if (!grid) return;
    var chk = $('[data-hide-sold]'), none = $('#grid-none');
    function apply() {
      var hide = chk && chk.checked, shown = 0;
      $$('.card', grid).forEach(function (c) {
        var out = c.getAttribute('data-available') === 'false';
        c.hidden = !!(hide && out);
        if (!c.hidden) shown++;
      });
      if (none) none.hidden = shown > 0 || !$('.card', grid);
    }
    if (chk) {
      try { chk.checked = sessionStorage.getItem('somar-instock') === '1'; } catch (e) {}
      chk.addEventListener('change', function () {
        try { sessionStorage.setItem('somar-instock', chk.checked ? '1' : '0'); } catch (e) {}
        apply();
      });
      apply();
    }
    var sel = $('[data-sort-select]');
    if (sel) sel.addEventListener('change', function () {
      var u = new URL(location.href);
      u.searchParams.set('sort_by', sel.value);
      u.searchParams.delete('page');
      navigateTo(u.pathname + u.search);
    });
  });

  /* ── Search overlay with predictive results ──────────────────────────── */
  safe(function () {
    var ov = $('#search-ov');
    if (!ov) return;
    var input = $('#search-input'), out = $('#search-results');
    var timer = null, lastQ = '', ctrl = null;

    d.addEventListener('click', function (e) {
      if (e.target.closest('[data-search-open]')) {
        e.preventDefault();
        var nav = $('#nav-drawer');
        if (nav && stack.indexOf(nav) !== -1) closeLayer(nav, true);
        openLayer(ov, { focus: '#search-input' });
      } else if (e.target.closest('[data-search-close]') || e.target === ov) {
        closeLayer(ov);
      }
    });

    function render(q, products) {
      if (!out) return;
      if (!q) { out.innerHTML = ''; return; }
      var all = '<a class="sr-all" href="' + ROOT + 'search?q=' + encodeURIComponent(q) + '">VIEW ALL RESULTS FOR "' + esc(q.toUpperCase()) + '" <span aria-hidden="true">›</span></a>';
      if (!products.length) { out.innerHTML = '<p class="sr-empty">NO DIRECT MATCH.</p>' + all; return; }
      out.innerHTML = products.map(function (p) {
        var cents = Math.round(parseFloat(p.price) * 100);
        var img = p.image ? (p.image + (p.image.indexOf('?') === -1 ? '?' : '&') + 'width=120') : '';
        return '<a class="sr-item" href="' + esc(p.url) + '">' +
          (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '<span></span>') +
          '<span class="sr-name">' + esc(p.title) + '</span>' +
          '<span class="sr-price">' + (p.available === false ? 'SOLD OUT' : (isNaN(cents) ? '' : esc(fmtMoney(cents)))) + '</span></a>';
      }).join('') + all;
    }

    function run() {
      var q = (input.value || '').trim();
      if (q === lastQ) return;
      lastQ = q;
      if (!q) { render('', []); return; }
      if (ctrl && ctrl.abort) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      fetch(ROOT + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last',
        { headers: { Accept: 'application/json' }, signal: ctrl ? ctrl.signal : undefined })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          if (q !== lastQ) return;
          var prods = (j && j.resources && j.resources.results && j.resources.results.products) || [];
          render(q, prods);
        })
        .catch(function (err) { if (!err || err.name !== 'AbortError') render(q, []); });
    }
    if (input) input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 200); });
    ov._onClose = function () { clearTimeout(timer); };
  });

  /* ── Product page ────────────────────────────────────────────────────── */
  safe(function () {
    var root = $('[data-product-root]');
    var jsonEl = $('[data-product-json]');
    if (!root || !jsonEl) return;
    var data;
    try { data = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    // Overlays live inside .main's stacking context — move them to <body> so they cover the header
    ['mag-scope', 'lightbox', 'sg-modal'].forEach(function (id) {
      $$('body > #' + id).forEach(function (stale) { if (!root.contains(stale)) stale.remove(); });
      var el = d.getElementById(id);
      if (el && el.parentNode !== body) body.appendChild(el);
    });
    var buybar = $('[data-buybar]');
    if (buybar) { $$('body > .buybar').forEach(function (s) { if (s !== buybar) s.remove(); }); body.appendChild(buybar); body.classList.add('has-buybar'); }

    var form = $('[data-product-form]');
    var idInput = form && $('[data-variant-input]', form);
    var sets = form ? $$('.opt', form) : [];
    var atcs = $$('[data-atc]');
    var priceNow = $('[data-price-now]'), priceWas = $('[data-price-was]');
    var stockEl = $('[data-stock-alert]'), errEl = $('[data-form-error]');
    var bbOpt = $('[data-buybar-opt]'), bbPrice = $('[data-buybar-price]');
    var multiOpt = data.options && data.options.length > 1;

    function selected() { return sets.map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; }); }
    function findVariant(opts) {
      for (var i = 0; i < data.variants.length; i++) {
        var v = data.variants[i], ok = true;
        for (var k = 0; k < opts.length; k++) if (v.options[k] !== opts[k]) { ok = false; break; }
        if (ok) return v;
      }
      return null;
    }

    function update(fromUser) {
      var opts = selected();
      var v = sets.length ? findVariant(opts) : data.variants[0];
      sets.forEach(function (fs, i) {
        var lbl = $('[data-option-value]', fs);
        if (lbl) lbl.textContent = (opts[i] || '').toUpperCase();
        $$('.opt-btn', fs).forEach(function (b) {
          var test = opts.slice(); test[i] = $('input', b).value;
          var tv = findVariant(test);
          b.classList.toggle('is-out', !tv || !tv.available);
        });
      });
      if (errEl) errEl.hidden = true;
      if (!v) {
        atcs.forEach(function (b) { b.disabled = true; b.textContent = 'UNAVAILABLE'; });
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceNow) priceNow.textContent = v.price;
      if (priceWas) { priceWas.hidden = !v.compare; priceWas.textContent = v.compare || ''; }
      atcs.forEach(function (b) {
        b.disabled = !v.available;
        b.textContent = v.available ? b.getAttribute('data-label') : b.getAttribute('data-soldout');
      });
      if (stockEl) {
        var low = v.managed === 'shopify' && v.qty > 0 && v.qty <= 5;
        stockEl.hidden = !low;
        if (low) stockEl.textContent = 'LOW STOCK — ONLY ' + v.qty + ' LEFT';
      }
      if (bbOpt) bbOpt.textContent = sets.length ? v.title.toUpperCase() + ' · ' : '';
      if (bbPrice) bbPrice.textContent = v.price;
      if (fromUser) {
        try { history.replaceState(history.state, '', data.url + '?variant=' + v.id); } catch (e) {}
        if (v.image) gallery.goToImage(v.image);
      }
    }

    if (form) {
      form.addEventListener('change', function () { update(true); });
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var live = atcs.filter(function (b) { return !b.disabled; });
        if (!live.length || !idInput) return;
        addToCart(idInput.value, 1, atcs).catch(function (err) {
          if (errEl) { errEl.textContent = (err && err.message ? err.message : 'COULD NOT ADD — TRY AGAIN').toUpperCase(); errEl.hidden = false; }
        });
      });
    }

    /* Gallery — native scroll-snap; arrows, thumbs, keys and counter follow it */
    var gallery = (function () {
      var track = $('[data-gal-track]', root);
      var slides = track ? $$('.gal-slide', track) : [];
      var imgs = slides.map(function (s) { return $('img', s); }).filter(Boolean);
      var thumbs = $$('[data-gal-thumb]', root);
      var prev = $('[data-gal-prev]', root), next = $('[data-gal-next]', root), count = $('[data-gal-count]', root);
      var userMoved = false;
      function idx() { return !track || slides.length < 2 ? 0 : Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / Math.max(1, track.clientWidth)))); }
      function sync() {
        var i = idx();
        thumbs.forEach(function (t, k) { t.classList.toggle('on', k === i); t.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
        if (count) count.textContent = pad(i + 1) + ' / ' + pad(slides.length);
        if (prev) prev.disabled = i === 0;
        if (next) next.disabled = i === slides.length - 1;
      }
      function go(i, instant) {
        if (!track) return;
        userMoved = true;
        i = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: i * track.clientWidth, behavior: instant || reduceMotion ? 'auto' : 'smooth' });
      }
      if (track && slides.length > 1) {
        var raf = null;
        track.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(function () { raf = null; sync(); }); }, { passive: true });
        ['touchstart', 'wheel', 'pointerdown'].forEach(function (ev) { track.addEventListener(ev, function () { userMoved = true; }, { passive: true }); });
        // Lazy images reflow the track while loading and mandatory snap can wander off
        // slide 1 (mobile Safari) — keep it pinned until the visitor actually moves it.
        var pin = function () { if (!userMoved && track.scrollLeft !== 0) { track.scrollLeft = 0; sync(); } };
        imgs.forEach(function (im) { if (!im.complete) im.addEventListener('load', pin); });
        window.addEventListener('load', pin);
        window.addEventListener('resize', function () { var i = idx(); track.scrollLeft = i * track.clientWidth; });
        track.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx() - 1); }
          if (e.key === 'ArrowRight') { e.preventDefault(); go(idx() + 1); }
        });
        sync();
      }
      if (prev) prev.addEventListener('click', function () { go(idx() - 1); });
      if (next) next.addEventListener('click', function () { go(idx() + 1); });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-gal-thumb'), 10)); }); });
      return {
        track: track, imgs: imgs, idx: idx, go: go,
        goToImage: function (imageId) {
          for (var i = 0; i < slides.length; i++) if (String(slides[i].getAttribute('data-image-id')) === String(imageId)) { go(i); return; }
        }
      };
    })();

    /* Lightbox */
    var lb = $('#lightbox'), lbImg = lb && $('[data-lb-img]', lb), lbCount = lb && $('[data-lb-count]', lb), lbI = 0;
    function lbShow(i) {
      var n = gallery.imgs.length;
      if (!n || !lbImg) return;
      lbI = (i + n) % n;
      var src = gallery.imgs[lbI];
      lbImg.src = src.getAttribute('data-full') || src.currentSrc || src.src;
      lbImg.alt = src.alt || '';
      if (lbCount) lbCount.textContent = pad(lbI + 1) + ' / ' + pad(n);
    }
    function lbOpen(i) { if (!lb) return; lbShow(i); openLayer(lb); }
    if (lb) {
      lb._onClose = function () { gallery.go(lbI, true); };
      $$('[data-lb-close]', lb).forEach(function (b) { b.addEventListener('click', function () { closeLayer(lb); }); });
      var lp = $('[data-lb-prev]', lb), ln = $('[data-lb-next]', lb), lbBody = $('[data-lb-body]', lb);
      if (lp) lp.addEventListener('click', function () { lbShow(lbI - 1); });
      if (ln) ln.addEventListener('click', function () { lbShow(lbI + 1); });
      if (lbBody) {
        lbBody.addEventListener('click', function (e) { if (e.target === lbBody) closeLayer(lb); });
        var sx = 0, sy = 0;
        lbBody.addEventListener('touchstart', function (e) { if (e.touches.length === 1) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; } }, { passive: true });
        lbBody.addEventListener('touchend', function (e) {
          if (e.changedTouches.length !== 1 || (window.visualViewport && visualViewport.scale > 1.05)) return;
          var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
          if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.4) lbShow(lbI + (dx < 0 ? 1 : -1));
        }, { passive: true });
      }
      d.addEventListener('keydown', function (e) {
        if (topLayer() !== lb) return;
        if (e.key === 'ArrowLeft') lbShow(lbI - 1);
        if (e.key === 'ArrowRight') lbShow(lbI + 1);
      });
    }

    var scopeJustEnded = 0;
    if (gallery.track) gallery.track.addEventListener('click', function (e) {
      if (Date.now() - scopeJustEnded < 450) return;
      if (e.target.tagName === 'IMG') lbOpen(gallery.idx());
    });

    /* Desktop: hover magnifier "sniper scope" */
    var scope = $('#mag-scope'), magView = $('#mag-view'), ZOOM = 2.8;
    function showScope(x, y, img) {
      if (!scope || !img) return;
      var rect = img.getBoundingClientRect();
      var natW = img.naturalWidth || rect.width, natH = img.naturalHeight || rect.height;
      var s = Math.min(rect.width / natW, rect.height / natH);
      var rw = natW * s, rh = natH * s;
      var ox = (rect.width - rw) / 2, oy = (rect.height - rh) / 2;
      var px = x - rect.left - ox, py = y - rect.top - oy;
      if (px < 0 || py < 0 || px > rw || py > rh) { scope.style.display = 'none'; return; }
      var SZ = scope.offsetWidth || 340;
      scope.style.display = 'block';
      var left = x + 28, top = y - SZ / 2;
      if (left + SZ > innerWidth - 8) left = x - SZ - 28;
      scope.style.left = left + 'px';
      scope.style.top = Math.max(8, Math.min(innerHeight - SZ - 8, top)) + 'px';
      // Hi-res on top, the already-loaded photo underneath so the lens is never blank while it streams in
      var hi = img.getAttribute('data-full') || img.currentSrc || img.src, lo = img.currentSrc || img.src;
      var bg = 'url("' + hi + '"), url("' + lo + '")';
      if (magView._bg !== bg) { magView.style.backgroundImage = bg; magView._bg = bg; }
      magView.style.backgroundSize = (rw * ZOOM) + 'px ' + (rh * ZOOM) + 'px';
      magView.style.backgroundPosition = (-(px * ZOOM - SZ / 2)) + 'px ' + (-(py * ZOOM - SZ / 2)) + 'px';
    }
    if (finePointer && scope && magView && gallery.track) {
      gallery.track.addEventListener('mousemove', function (e) { showScope(e.clientX, e.clientY, gallery.imgs[gallery.idx()]); });
      gallery.track.addEventListener('mouseleave', function () { scope.style.display = 'none'; });
      gallery.track.addEventListener('scroll', function () { scope.style.display = 'none'; }, { passive: true });
    }

    /* Phones: press-and-hold a product photo for the scope lens */
    if (!finePointer && gallery.track) {
      var lens = d.createElement('div'); lens.id = 'mob-scope';
      var lensImg = d.createElement('img'); lensImg.className = 'scope-zoom-img'; lensImg.alt = '';
      lens.appendChild(lensImg);
      ['scope-ring', 'scope-h', 'scope-v', 'scope-dot'].forEach(function (c) { var x = d.createElement('div'); x.className = c; lens.appendChild(x); });
      var lensBg = d.createElement('div'); lensBg.id = 'mob-scope-bg';
      body.appendChild(lensBg); body.appendChild(lens);
      var R = 75, Z = 2.8, holdT = null, active = false, sX = 0, sY = 0, target = null;
      function moveLens(x, y) {
        lens.style.left = x + 'px'; lens.style.top = (y - 90) + 'px';
        var r = target.getBoundingClientRect();
        var natW = target.naturalWidth || r.width, natH = target.naturalHeight || r.height;
        var s = Math.min(r.width / natW, r.height / natH), rw = natW * s, rh = natH * s;
        var ox = r.left + (r.width - rw) / 2, oy = r.top + (r.height - rh) / 2;
        var fx = Math.max(0, Math.min(1, (x - ox) / rw)), fy = Math.max(0, Math.min(1, (y - oy) / rh));
        var iw = rw * Z, ih = rh * Z;
        lensImg.style.display = 'block';
        lensImg.style.width = iw + 'px'; lensImg.style.height = ih + 'px';
        lensImg.style.left = (R - fx * iw) + 'px'; lensImg.style.top = (R - fy * ih) + 'px';
      }
      var onDrag = function (e) { e.preventDefault(); moveLens(e.touches[0].clientX, e.touches[0].clientY); };
      function end() {
        clearTimeout(holdT);
        if (!active) return;
        active = false; scopeJustEnded = Date.now();
        body.classList.remove('scope-on');
        d.removeEventListener('touchmove', onDrag);
      }
      gallery.track.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1 || e.target.tagName !== 'IMG') return;
        target = e.target; sX = e.touches[0].clientX; sY = e.touches[0].clientY;
        holdT = setTimeout(function () {
          active = true;
          lensImg.src = target.getAttribute('data-full') || target.currentSrc || target.src;
          body.classList.add('scope-on');
          moveLens(sX, sY);
          d.addEventListener('touchmove', onDrag, { passive: false });
          if (navigator.vibrate) navigator.vibrate(30);
        }, 450);
      }, { passive: true });
      gallery.track.addEventListener('touchmove', function (e) {
        if (active) return;
        var t = e.touches[0];
        if (Math.abs(t.clientX - sX) > 10 || Math.abs(t.clientY - sY) > 10) clearTimeout(holdT);
      }, { passive: true });
      gallery.track.addEventListener('touchend', end, { passive: true });
      gallery.track.addEventListener('touchcancel', end, { passive: true });
      gallery.track.addEventListener('contextmenu', function (e) { e.preventDefault(); });
    }

    /* Phones: sticky buy bar once the main button scrolls past */
    var mainAtc = form && $('[data-atc]', form);
    if (buybar && mainAtc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var en = entries[0];
        var show = !en.isIntersecting && en.boundingClientRect.top < 0;
        buybar.classList.toggle('show', show);
        buybar.setAttribute('aria-hidden', show ? 'false' : 'true');
        $$('button', buybar).forEach(function (b) { b.tabIndex = show ? 0 : -1; });
      }, { threshold: 0 }).observe(mainAtc);
    }

    update(false);
  });

  /* ── Home dashboard: Xbox-style blades ───────────────────────────────── */
  safe(function () {
    var items = $$('.dash-item');
    if (!items.length) return;
    var dots = $$('[data-dash-dot]');
    var active = 0;
    var A = 210, STEP = 0.3;

    /* Fixed arc that hugs the orb (middle blades sit furthest out, like the original
       dashboard). It never moves on hover — only the active blade pops forward. */
    function layout() {
      var desk = mqDesk.matches, n = items.length, mid = (n - 1) / 2;
      var edge = 1 - Math.cos(mid * STEP);
      items.forEach(function (el, i) {
        if (!desk) { el.style.transform = ''; return; }
        var x = A * (edge - (1 - Math.cos((i - mid) * STEP)));
        if (i === active) x += 10;
        el.style.transform = 'translateX(' + x.toFixed(1) + 'px)';
      });
    }
    function setActive(i, focus) {
      active = Math.max(0, Math.min(items.length - 1, i));
      items.forEach(function (el, k) { el.classList.toggle('on', k === active); });
      dots.forEach(function (dt, k) { dt.classList.toggle('on', k === active); });
      $$('[data-hud-chan]').forEach(function (c) { c.textContent = pad(active + 1); });
      layout();
      if (focus) items[active].focus({ preventScroll: true });
    }
    items.forEach(function (el, i) {
      el.addEventListener('mouseenter', function () { if (mqDesk.matches) setActive(i); });
      el.addEventListener('focus', function () { if (active !== i) setActive(i); });
    });
    dots.forEach(function (dt, i) { dt.addEventListener('click', function () { if (items[i]) items[i].click(); }); });
    d.addEventListener('keydown', function (e) {
      if (topLayer()) return;
      var tag = (d.activeElement && d.activeElement.tagName) || '';
      if (/INPUT|TEXTAREA|SELECT/.test(tag)) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); setActive(active + 1, true); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(active - 1, true); }
      else if (e.key === 'Enter' && d.activeElement === body) { e.preventDefault(); items[active].click(); }
    });
    if (mqDesk.addEventListener) mqDesk.addEventListener('change', layout); else if (mqDesk.addListener) mqDesk.addListener(layout);
    setActive(0);
  });

  /* ── Countdowns: limited pre-order + coming-soon drop ────────────────── */
  safe(function () {
    var els = $$('[data-po-countdown]');
    if (!els.length) return;
    var iv;
    function closeOut() {
      $$('[data-atc]').forEach(function (b) { b.disabled = true; b.textContent = 'PRE-ORDER CLOSED'; });
      $$('.po-panel').forEach(function (p) { p.classList.add('po-is-closed'); });
      $$('.po-badge').forEach(function (b) { b.classList.add('po-closed'); b.textContent = 'PRE-ORDER CLOSED'; });
    }
    function tick() {
      var live = false;
      els.forEach(function (el) {
        var t = new Date(el.getAttribute('data-po-countdown')).getTime();
        if (isNaN(t)) { el.textContent = 'SOON'; return; }
        var diff = t - Date.now();
        if (diff <= 0) {
          if (el.getAttribute('data-po-scope') === 'page') { el.textContent = '—'; closeOut(); }
          else { el.classList.add('po-closed'); el.textContent = 'PRE-ORDER CLOSED'; var qa = el.closest('.card') && $('.card-qa', el.closest('.card')); if (qa) qa.remove(); }
          return;
        }
        live = true;
        var dd = Math.floor(diff / 864e5), h = Math.floor(diff % 864e5 / 36e5), m = Math.floor(diff % 36e5 / 6e4), s = Math.floor(diff % 6e4 / 1e3);
        if (el.getAttribute('data-po-scope') === 'page') el.textContent = (dd > 0 ? dd + 'D ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
        else el.textContent = dd > 0 ? 'PRE-ORDER · ' + dd + 'D LEFT' : 'PRE-ORDER · ' + pad(h) + ':' + pad(m) + ':' + pad(s);
      });
      if (!live) clearInterval(iv);
    }
    tick(); iv = setInterval(tick, 1000);
  });
  safe(function () {
    $$('.product-mini-cd').forEach(function (el) {
      var target = new Date(el.getAttribute('data-drop')).getTime(), iv;
      if (isNaN(target)) { el.textContent = 'SOON'; return; }
      function upd() {
        var diff = target - Date.now();
        if (diff <= 0) { el.textContent = 'LIVE'; clearInterval(iv); return; }
        var dd = Math.floor(diff / 864e5), h = Math.floor(diff % 864e5 / 36e5), m = Math.floor(diff % 36e5 / 6e4), s = Math.floor(diff % 6e4 / 1e3);
        el.textContent = (dd > 0 ? dd + 'D ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
      }
      upd(); iv = setInterval(upd, 1000);
    });
  });

  /* ── Intro video (first visit only) ──────────────────────────────────── */
  safe(function () {
    var vi = $('#video-intro');
    if (!vi || inEditor) return;
    var seen = false;
    try { seen = localStorage.getItem('somar-intro-seen') === '1'; } catch (e) {}
    if (seen) return;
    var player = $('#vi-player');
    vi._onClose = function () {
      try { localStorage.setItem('somar-intro-seen', '1'); } catch (e) {}
      if (player) player.pause();
    };
    openLayer(vi);
    if (player) { player.preload = 'auto'; var p = player.play(); if (p && p.catch) p.catch(function () {}); }
    $$('[data-vi-close]', vi).forEach(function (b) { b.addEventListener('click', function () { closeLayer(vi); }); });
  });

  /* ── Promo popup ─────────────────────────────────────────────────────── */
  safe(function () {
    var pop = $('#promo-popup');
    if (!pop) return;
    var KEY = 'smr_popup_v1';
    var always = pop.getAttribute('data-always') === 'true';
    var seen = false;
    try { seen = !!sessionStorage.getItem(KEY); } catch (e) {}
    if (!always && seen) return;
    pop._onClose = function () { try { sessionStorage.setItem(KEY, '1'); } catch (e) {} };
    $$('[data-promo-close]', pop).forEach(function (b) { b.addEventListener('click', function () { closeLayer(pop); }); });
    var code = $('[data-copy]', pop);
    if (code) code.addEventListener('click', function () {
      var v = code.getAttribute('data-copy');
      if (navigator.clipboard) navigator.clipboard.writeText(v).then(function () { toast('CODE COPIED'); }, function () {});
    });
    setTimeout(function () {
      // Never stack over the intro video or an open drawer
      if (topLayer()) return;
      openLayer(pop);
    }, parseInt(pop.getAttribute('data-delay'), 10) || 1200);
  });

  /* ── HUD clock ───────────────────────────────────────────────────────── */
  safe(function () {
    var MONTHS = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
    var times = $$('[data-hud-time]'), dates = $$('[data-hud-date]');
    if (!times.length && !dates.length) return;
    function tick() {
      var n = new Date();
      var t = pad(n.getHours()) + ':' + pad(n.getMinutes()) + ':' + pad(n.getSeconds());
      var dt = MONTHS[n.getMonth()] + ' ' + n.getDate() + ' ' + n.getFullYear();
      times.forEach(function (e) { e.textContent = t; });
      dates.forEach(function (e) { e.textContent = dt; });
    }
    tick(); setInterval(tick, 1000);
  });

  /* ── Desktop: crosshair cursor, reticle lines, hit markers ───────────── */
  var VP = { tx: 0, ty: 0, vAz: 0, vEl: 0 };
  safe(function () {
    if (!finePointer) return;
    var cur = $('#cur'), rh = $('#rh'), rv = $('#rv');
    var lat = $('#hlat'), lon = $('#hlon'), brg = $('#hbrg');
    html.classList.add('has-cur');
    d.addEventListener('mousemove', function (e) {
      var x = e.clientX, y = e.clientY;
      if (cur) { cur.style.left = x + 'px'; cur.style.top = y + 'px'; cur.style.opacity = '1'; }
      if (rh) rh.style.top = y + 'px';
      if (rv) rv.style.left = x + 'px';
      VP.tx = (x / innerWidth - 0.5) * 2;
      VP.ty = (y / innerHeight - 0.5) * 2;
      if (lat) lat.textContent = (33.677 - VP.ty * 0.015).toFixed(5);
      if (lon) lon.textContent = (-82.273 + VP.tx * 0.022).toFixed(5);
      if (brg) brg.textContent = pad(Math.round(((Math.atan2(VP.tx, -VP.ty) * 180 / Math.PI) + 360) % 360), 3);
      if (window.__somarWake) window.__somarWake();
    }, { passive: true });
    d.addEventListener('mouseleave', function () { if (cur) cur.style.opacity = '0'; });
    d.addEventListener('click', function (e) {
      if (!e.target.closest('a,button,input,select,label,summary,[role="button"]')) return;
      var hm = d.createElement('div');
      hm.className = 'hm';
      hm.style.left = e.clientX + 'px'; hm.style.top = e.clientY + 'px';
      for (var i = 0; i < 4; i++) { var l = d.createElement('div'); l.className = 'hm-l'; hm.appendChild(l); }
      body.appendChild(hm);
      setTimeout(function () { hm.remove(); }, 420);
    });
  });

  /* ── Background: spherical grid canvas + compass + gyro ──────────────── */
  safe(function () {
    var c = $('#bgc');
    if (!c || !c.getContext) return;
    var ctx = c.getContext('2d');
    var CW = 0, CH = 0, dirty = true, running = false, lastEl = 1e9, lastAz = 1e9;
    var tape = $('#ct'), hmag = $('#hmag');
    // .htc is position:fixed, so offsetParent is always null — check for a rendered box instead
    var compassOn = function () { var h = $('.htc'); return !!(h && h.getClientRects().length); };

    function resize() { CW = c.width = innerWidth; CH = c.height = innerHeight; dirty = true; wake(); }
    window.addEventListener('resize', resize);

    function proj(lat, lon, vEl, vAz) {
      var D = Math.PI / 180, la = lat * D, lo = lon * D, e = vEl * D, a = vAz * D;
      var x0 = Math.cos(la) * Math.sin(lo), y0 = Math.sin(la), z0 = Math.cos(la) * Math.cos(lo);
      var x1 = x0 * Math.cos(-a) + z0 * Math.sin(-a), z1 = -x0 * Math.sin(-a) + z0 * Math.cos(-a);
      var y2 = y0 * Math.cos(-e) - z1 * Math.sin(-e), z2 = y0 * Math.sin(-e) + z1 * Math.cos(-e);
      if (z2 <= 0.01) return null;
      var sc = Math.min(CW, CH) * 0.62;
      return [CW / 2 + (x1 / z2) * sc, CH / 2 - (y2 / z2) * sc];
    }
    function line(fixed, isLat, from, to, step, vEl, vAz) {
      ctx.beginPath();
      var pen = false;
      for (var t = from; t <= to; t += step) {
        var p = isLat ? proj(fixed, t, vEl, vAz) : proj(t, fixed, vEl, vAz);
        if (!p) { pen = false; continue; }
        if (pen) ctx.lineTo(p[0], p[1]); else { ctx.moveTo(p[0], p[1]); pen = true; }
      }
      ctx.stroke();
    }
    function draw(vEl, vAz) {
      var dark = html.classList.contains('dark-mode');
      ctx.globalAlpha = 1;
      ctx.fillStyle = dark ? '#0e0e0e' : '#d4d4d4';
      ctx.fillRect(0, 0, CW, CH);
      var g = ctx.createRadialGradient(CW / 2, CH / 2, 0, CW / 2, CH / 2, Math.max(CW, CH) * 0.72);
      g.addColorStop(0, dark ? 'rgba(30,30,30,.2)' : 'rgba(230,230,230,.2)');
      g.addColorStop(0.5, 'rgba(0,0,0,0)');
      g.addColorStop(1, dark ? 'rgba(0,0,0,.28)' : 'rgba(150,150,150,.18)');
      ctx.fillStyle = g; ctx.fillRect(0, 0, CW, CH);
      ctx.strokeStyle = dark ? '#2e2e2e' : '#888';
      ctx.lineWidth = 0.3; ctx.globalAlpha = 0.18;
      var i;
      for (i = -80; i <= 80; i += 5) if (i % 15) line(i, true, -180, 180, 3, vEl, vAz);
      for (i = -180; i <= 180; i += 5) if (i % 15) line(i, false, -89, 89, 3, vEl, vAz);
      for (i = -75; i <= 75; i += 15) { ctx.lineWidth = i === 0 ? 1 : 0.55; ctx.globalAlpha = i === 0 ? 0.5 : 0.35; line(i, true, -180, 180, 2, vEl, vAz); }
      ctx.lineWidth = 0.55; ctx.globalAlpha = 0.35;
      for (i = -165; i <= 180; i += 15) line(i, false, -89, 89, 2, vEl, vAz);
      ctx.fillStyle = dark ? '#3a3a3a' : '#666';
      for (var la = -75; la <= 75; la += 15) for (var lo = -165; lo <= 180; lo += 15) {
        var p = proj(la, lo, vEl, vAz); if (!p) continue;
        ctx.globalAlpha = 0.5 - Math.abs(la) / 75 * 0.2;
        ctx.beginPath(); ctx.arc(p[0], p[1], 1.6, 0, Math.PI * 2); ctx.fill();
      }
      ctx.globalAlpha = 1;
    }

    // Compass tape — erratic drift
    var SEG = ['N','·','·','|','·','·','NE','·','·','|','·','·','E','·','·','|','·','·','SE','·','·','|','·','·','S','·','·','|','·','·','SW','·','·','|','·','·','W','·','·','|','·','·','NW','·','·','|','·','·'];
    var CARD = { N: 1, NE: 1, E: 1, SE: 1, S: 1, SW: 1, W: 1, NW: 1 };
    var ONE = SEG.length * 22, TOTAL = ONE * 5, cVel = 0.8, cPos = 0;
    if (tape) { var hh = ''; for (var r = 0; r < 5; r++) SEG.forEach(function (s) { hh += '<span' + (CARD[s] ? ' class="cc"' : '') + '>' + s + '</span>'; }); tape.innerHTML = hh; }
    function tickCompass() {
      cVel += 0.22;
      if (Math.random() < 0.065) cVel += (Math.random() - 0.32) * 32;
      if (Math.random() < 0.02) cVel -= Math.random() * 18;
      cVel *= 0.915;
      cPos = ((cPos + cVel * 0.05) % TOTAL + TOTAL) % TOTAL;
      tape.style.transform = 'translateX(' + (-(cPos % ONE) - ONE) + 'px)';
      if (hmag) hmag.textContent = pad(Math.round((cPos / ONE * 360) % 360), 3);
    }

    // Gyro (phones) — Android starts automatically; iOS needs a tap on the home sigil
    var G = { on: false, az: 0, el: 0, sAz: 0, sEl: 0, seeded: false, b0: null, g0: null };
    var sw = $('.sw');
    function onOrient(ev) {
      if (ev.alpha == null && ev.beta == null) return;
      G.az = 360 - (ev.alpha || 0);
      G.el = Math.max(-80, Math.min(80, 60 - (ev.beta || 0)));
      if (!G.seeded) { G.sAz = G.az; G.sEl = G.el; G.b0 = ev.beta || 0; G.g0 = ev.gamma || 0; G.seeded = true; }
      G.on = true;
      if (sw && isHome && !reduceMotion) {
        var db = Math.max(-25, Math.min(25, (ev.beta || 0) - G.b0)), dg = Math.max(-25, Math.min(25, (ev.gamma || 0) - G.g0));
        sw.style.transform = 'perspective(600px) rotateX(' + (db * 0.45).toFixed(1) + 'deg) rotateY(' + (dg * 0.45).toFixed(1) + 'deg)';
      }
      wake();
    }
    function enableGyro() { window.addEventListener('deviceorientation', onOrient, true); }
    if (!finePointer && !reduceMotion && 'DeviceOrientationEvent' in window) {
      if (typeof DeviceOrientationEvent.requestPermission === 'function') {
        var sig = isHome && $('[data-sigil]');
        if (sig) sig.addEventListener('click', function (e) {
          e.preventDefault();
          DeviceOrientationEvent.requestPermission().then(function (s) { if (s === 'granted') { enableGyro(); toast('GYRO LINKED'); } }).catch(function () {});
        });
      } else enableGyro();
    }
    if (isHome) {
      var sigLink = $('[data-sigil]');
      if (sigLink && finePointer) sigLink.addEventListener('click', function (e) { e.preventDefault(); });
    }

    function frame() {
      running = false;
      if (d.hidden) return;
      var vEl, vAz, more = false;
      if (G.on) {
        var dAz = ((G.az - G.sAz + 540) % 360) - 180;
        G.sAz = (G.sAz + dAz * 0.12 + 360) % 360;
        G.sEl += (G.el - G.sEl) * 0.12;
        vEl = G.sEl; vAz = G.sAz;
        more = Math.abs(dAz) > 0.05 || Math.abs(G.el - G.sEl) > 0.05;
      } else {
        var nx = Math.sign(VP.tx) * Math.pow(Math.abs(VP.tx), 1.4), ny = Math.sign(VP.ty) * Math.pow(Math.abs(VP.ty), 1.4);
        VP.vAz += (nx * 40 - VP.vAz) * 0.065;
        VP.vEl += (-ny * 25 - VP.vEl) * 0.065;
        vEl = VP.vEl; vAz = VP.vAz;
        more = Math.abs(nx * 40 - VP.vAz) > 0.02 || Math.abs(-ny * 25 - VP.vEl) > 0.02;
      }
      if (dirty || Math.abs(vEl - lastEl) > 0.01 || Math.abs(vAz - lastAz) > 0.01) {
        draw(vEl, vAz); lastEl = vEl; lastAz = vAz; dirty = false;
      }
      var comp = tape && compassOn() && !reduceMotion;
      if (comp) tickCompass();
      if (more || comp) wake();
    }
    function wake() { if (!running) { running = true; requestAnimationFrame(frame); } }
    window.__somarWake = wake;
    window.__somarRedraw = function () { dirty = true; wake(); };
    d.addEventListener('visibilitychange', function () { if (!d.hidden) { dirty = true; wake(); } });
    resize();
  });

  /* ── Password page: focus the code field on desktop only (no surprise keyboard on phones) ── */
  safe(function () {
    if (!body.classList.contains('template-password') || !finePointer) return;
    var pw = $('#pw-input');
    if (pw) pw.focus({ preventScroll: true });
  });

  /* ── Back/forward cache: page comes back exactly as it was left ──────── */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    if (veil) veil.classList.remove('out');
    closeAll();
    refreshCart();
  });
})();
